import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CoreHttpService {

  constructor(private httpClient:HttpClient) { }

getSecured(url, params?) {
  if (params) {
    return this.httpClient.get(url, params);
  } else {
    return this.httpClient.get(url);
  }
}

postSecured(url, payload) {
  return this.httpClient.post(url, payload);
}

postSecuredWithHeaders(url, payload, headers?) {
  return this.httpClient.post(url, payload, headers);
}
putSecured(url, payload, params?) {
  if (params) {
    return this.httpClient.put(url, payload, params);
  } else {
    return this.httpClient.put(url, payload);
  }
}
deleteSecured(url,params) {
  return this.httpClient.delete(url,params);
}
deleteSecuredWithParams(url, params) {
  return this.httpClient.delete(url, params);
}
patchSecured(url, payload, params) {
  if (params) {
    return this.httpClient.patch(url, payload, params);
  } else {
    return this.httpClient.patch(url, payload);
  }
}

}
